import React, { useEffect, useState } from "react";
import axios from "axios";
import './events.css';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Events = () => {
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const cards = document.querySelectorAll(".event-card");
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15 }
        );
        cards.forEach(card => observer.observe(card));

        return () => observer.disconnect();
    }, [events]);

    const getImagePath = (imagePath) => {
        if (!imagePath) return "";
        if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
            return imagePath;
        }
        const parts = imagePath.split('/');
        const filename = parts[parts.length - 1];
        return `/images/${filename}`;
    };

    const handleEventClick = (eventId) => {
    if (eventId === "998") {
        window.location.href = "https://esmaaash.in/RED-ZONE/index.php";
    }
};


    useEffect(() => {
        axios.get('https://esmaaash.in/esmaaash_web/backend/api/get_events.php')
            .then(response => {
                if (Array.isArray(response.data)) {
                    setEvents(response.data);
                } else {
                    console.warn("Expected array but got:", response.data);
                    setEvents([]);
                }
            })
            .catch(error => {
                console.error("Error fetching events:", error);
                setEvents([]);
            });
    }, []);

    const isEventLive = (event) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startParts = event.event_date.split('-');
        const startDate = new Date(`${startParts[2]}-${startParts[1]}-${startParts[0]}`);
        startDate.setHours(0, 0, 0, 0);

        let endDate = event.end_date && event.end_date !== "0000-00-00"
            ? new Date(`${event.end_date.split('-').reverse().join('-')}`)
            : startDate;
        endDate.setHours(0, 0, 0, 0);

        return today >= startDate && today <= endDate;
    };

    const isEventUpcoming = (event) => {
        const today = new Date();
        const startDate = new Date(event.event_date.split('-').reverse().join('-'));
        return startDate > today;
    };

    const isEventPast = (event) => {
        const today = new Date();
        const endDate = new Date((event.end_date || event.event_date).split('-').reverse().join('-'));
        return endDate < today;
    };

    const formatDate = (dateString) => {
        if (!dateString || dateString === "0000-00-00") return "";
        const [day, month, year] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };

    const renderEventCard = (event, isFixed = false) => (
        <div key={isFixed ? `fixed-${event.id}` : event.id} className="event-card">
            <img
                src={isFixed ? getImagePath(event.image) : `https://esmaaash.in/esmaaash_web/${event.image}`}
                alt={event.name}
                className="event-image"
            />
            <div className="event-card-content">
                <h2 className="event-name">
                    {event.name} {isEventLive(event) && <span className="live-badge">LIVE</span>}
                </h2>
                <p className="event-tagline">{event.tagline}</p>
                {event.event_date || event.end_date ? (
                    event.end_date ? (
                        <>
                            <p className="event-details"><strong>Start Date:</strong> {formatDate(event.event_date)}</p>
                            <p className="event-details"><strong>End Date:</strong> {formatDate(event.end_date)}</p>
                        </>
                    ) : (
                        <p className="event-details"><strong>Event Date:</strong> {formatDate(event.event_date)}</p>
                    )
                ) : null}
                <p className="event-details"><strong>Location:</strong> {event.location}</p>
                <p className="event-price">Entry Fee : ₹{event.price}</p>

                {((isEventLive(event) || isEventUpcoming(event)) || event.showBookNow) && (
                    isFixed ? (
                        <button className="event-button" onClick={() => handleEventClick(event.id)}>Book Now</button>
                    ) : (
                        <a href={`/register/${event.id}`} target="_blank" rel="noopener noreferrer">
                            <button className="event-button">Book Now</button>
                        </a>
                    )
                )}
            </div>
        </div>
    );

    const renderEventsSection = (filterFn, title, showPrice = true) => {
        const showLeaderboard = true;
        let filteredEvents = events.filter(filterFn);

        

        filteredEvents.sort((a, b) => {
            const getStartDate = (event) =>
                new Date(event.event_date.split('-').reverse().join('-'));
            const getEndDate = (event) =>
                new Date((event.end_date && event.end_date !== "0000-00-00"
                    ? event.end_date
                    : event.event_date
                ).split('-').reverse().join('-'));
            if (title === "Past Events") {
                return getEndDate(b) - getEndDate(a);
            }
            return getStartDate(a) - getStartDate(b);
        });

        if (filteredEvents.length === 0) return null;

        return (
            <div className="events-section">
                <div className="events-heading-container">
                    <h2 className="events-heading">{title}</h2>
                    {title === "Live Events" && showLeaderboard && (
                        <a
                            href="https://esmaaash.in/esmaaash_web/Leaderboard/frontend/index.php"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="leaderboard-button"
                        >
                            🏆 Leaderboard
                        </a>
                    )}
                </div>
                <div className="events-grid">
                    {filteredEvents.map((event) => renderEventCard(event))}
                </div>
            </div>
        );
    };

    return (
        <div className="p-6">
            {/* ✅ SEO Meta Tags + Open Graph + JSON-LD */}
            <Helmet>
                <title>Esmaaash Events | Chess, eSports & Bowling Tournaments</title>
                <meta name="description" content="Register for upcoming chess, eSports (BGMI, FIFA) tournaments at Esmaaash. Join fun-filled competitions, win prizes, and showcase your skills!" />
                <meta name="keywords" content="Esmaaash events, RadiantRumble, gaming tournaments, eSports India, register event" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://esmaaash.in/events" />

                {/* Open Graph */}
                <meta property="og:title" content="Esmaaash Events | Chess, eSports & Bowling Tournaments" />
                <meta property="og:description" content="Register for upcoming chess, eSports (BGMI, FIFA) tournaments at Esmaaash. Join fun-filled competitions, win prizes, and showcase your skills!" />
                <meta property="og:image" content="https://esmaaash.in/images/bowlingt2.jpg" />
                <meta property="og:url" content="https://esmaaash.in/events" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Esmaaash Events | Chess, eSports & Bowling Tournaments" />
                <meta name="twitter:description" content="Register for upcoming chess, eSports (BGMI, FIFA) tournaments at Esmaaash. Join fun-filled competitions, win prizes, and showcase your skills!" />
                <meta name="twitter:image" content="https://esmaaash.in/images/bowlingt2.jpg" />

                {/* JSON-LD for Events */}
<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@graph": events.map(event => ({
      "@type": "Event",
      "name": event.name,
      "startDate": event.event_date,
      "endDate": event.end_date,
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "Place",
        "name": event.location
      },
      "image": [`https://esmaaash.in/esmaaash_web/${event.image}`],
      "description": event.tagline,
      "url": `https://esmaaash.in/register/${event.id}`
    }))
  })}
</script>


            </Helmet>

            {renderEventsSection(isEventLive, "Live Events", true)}
            {renderEventsSection(isEventUpcoming, "Upcoming Events", true)}
            {renderEventsSection(isEventPast, "Past Events", false)}
        </div>
    );
};

export default Events;
